import { render, staticRenderFns } from "./table-form-zgy.vue?vue&type=template&id=94a0728e&scoped=true&"
import script from "./table-form-zgy.vue?vue&type=script&lang=js&"
export * from "./table-form-zgy.vue?vue&type=script&lang=js&"
import style0 from "./table-form-zgy.vue?vue&type=style&index=0&id=94a0728e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a0728e",
  null
  
)

export default component.exports